import styled from 'styled-components';

export default styled.div`
  position: fixed;
  display: flex;
  height: 100vh;
`;
